export const parseObjectPositionToRatios = (objectPosition?: string) => {
    const pos = (objectPosition || '50% 50%').trim().split(/\s+/);
    const mapToken = (t: string, fallback = 0.5) => {
        const token = t.toLowerCase();
        if (token === 'left' || token === 'top') return 0;
        if (token === 'center') return 0.5;
        if (token === 'right' || token === 'bottom') return 1;
        if (token.endsWith('%')) return Math.max(0, Math.min(1, parseFloat(token) / 100));
        if (token.endsWith('px')) return token; // spezielle px-Angabe, wird später relativiert
        // Fallback: Prozent-Ratio
        const num = Number(token);
        return Number.isFinite(num) ? Math.max(0, Math.min(1, num)) : fallback;
    };
    const x = mapToken(pos[0] || '50%');
    const y = mapToken(pos[1] || '50%');
    return { x, y } as const; // kann Zahl (0..1) oder 'Npx' enthalten
};

export const resolveObjectPositionOffsets = (
    computedStyle: CSSStyleDeclaration | null,
    containerW: number,
    containerH: number,
    naturalW: number,
    naturalH: number,
) => {
    const fit = computedStyle?.objectFit || 'fill';
    // scale-Faktor gemäß object-fit
    const scale = fit === 'cover'
        ? Math.max(containerW / naturalW, containerH / naturalH)
        : fit === 'contain'
            ? Math.min(containerW / naturalW, containerH / naturalH)
            : containerW / naturalW; // Näherung für andere Fälle

    const scaledW = naturalW * scale;
    const scaledH = naturalH * scale;

    const overflowX = Math.max(0, scaledW - containerW);
    const overflowY = Math.max(0, scaledH - containerH);

    // object-position: Anteil der Überstände je Achse
    const raw = parseObjectPositionToRatios(computedStyle?.objectPosition || '50% 50%');
    const toRatio = (token: number | string, overflow: number) => {
        if (typeof token === 'number') return token; // bereits 0..1
        if (token.endsWith('px')) {
            const px = parseFloat(token);
            return overflow > 0 ? Math.max(0, Math.min(1, px / overflow)) : 0.5;
        }
        return 0.5;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ratioX = toRatio(raw.x as any, overflowX);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ratioY = toRatio(raw.y as any, overflowY);

    const offsetX = overflowX * ratioX; // wie viel links abgeschnitten ist
    const offsetY = overflowY * ratioY; // wie viel oben abgeschnitten ist

    return { scaledW, scaledH, offsetX, offsetY } as const;
};